"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInvoiceInDateRange = void 0;
function isInvoiceInDateRange(invoice, startDate, endDate) {
    return new Date(invoice.start_date) >= startDate && new Date(invoice.end_date) <= endDate;
}
exports.isInvoiceInDateRange = isInvoiceInDateRange;
